<template>
    <v-autocomplete
            hide-details
            v-model="pickedId"
            :items="items"
            item-value="id"
            item-text="name"
            outlined
            hide-no-data
            :loading="isLoading"
            @change="onChange"
            v-bind="$attrs"
    ></v-autocomplete>
</template>

<script>
  import CountryService from '@/services/country.service.js';

  export default {
    name: "CountryPickerInput",
    props: {
      value: {},
      label: { type: String, default: 'Pay'}
    },
    data() {
      return {
        pickedId: '',
        isLoading: false,
        items: [],
      }
    },
    created() {
      this.loadListItem();
    },
    methods: {
      async loadListItem() {
        const _this = this;

        this.isLoading = true;

        try {
          const {data} = await CountryService.getList();

          _this.items = data;
        } catch (e) {
            this.handleError(e)
        }

        this.isLoading = false;
      },
      onChange(event) {
        this.$emit('input', event);
      }
    },
    watch: {
      value: {
        immediate: true,
        handler(value) {
          this.pickedId = value;
        }
      }
    }
  }
</script>

<style scoped>

</style>
